// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.entries-empty-wrapper {
    position: relative;
    height: 100%;
}

.entries-empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    gap: 0.75rem;
    color: var(--light-grey-color);
    opacity: 0.35;
}

.entries-empty-wrapper .add-dose-fab.empty {
    top: 50%;
    left: 50%;
    right: auto;
    bottom: auto;
    margin: calc(var(--fab-size) / -2) 0 0 calc(var(--fab-size) / -2);
    transform: rotate(150deg) translate(0, -5rem) rotate(-150deg);
}

.entries-empty-icon {
    width: 10rem;
    height: 10rem;
}

.entries-empty-label {
    margin: 0;
    font-size: 1.4rem;
    letter-spacing: 0.05em;
}
`, "",{"version":3,"sources":["webpack://./src/components/entries/EmptyState.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,YAAY;IACZ,8BAA8B;IAC9B,aAAa;AACjB;;AAEA;IACI,QAAQ;IACR,SAAS;IACT,WAAW;IACX,YAAY;IACZ,iEAAiE;IACjE,6DAA6D;AACjE;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,SAAS;IACT,iBAAiB;IACjB,sBAAsB;AAC1B","sourcesContent":[".entries-empty-wrapper {\n    position: relative;\n    height: 100%;\n}\n\n.entries-empty {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    height: 100%;\n    gap: 0.75rem;\n    color: var(--light-grey-color);\n    opacity: 0.35;\n}\n\n.entries-empty-wrapper .add-dose-fab.empty {\n    top: 50%;\n    left: 50%;\n    right: auto;\n    bottom: auto;\n    margin: calc(var(--fab-size) / -2) 0 0 calc(var(--fab-size) / -2);\n    transform: rotate(150deg) translate(0, -5rem) rotate(-150deg);\n}\n\n.entries-empty-icon {\n    width: 10rem;\n    height: 10rem;\n}\n\n.entries-empty-label {\n    margin: 0;\n    font-size: 1.4rem;\n    letter-spacing: 0.05em;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
